import { render, staticRenderFns } from "./sfc-best-529-plans-widget.vue?vue&type=template&id=738135ec&scoped=true&lang=pug&"
import script from "./sfc-best-529-plans-widget.vue?vue&type=script&lang=js&"
export * from "./sfc-best-529-plans-widget.vue?vue&type=script&lang=js&"
import style0 from "./sfc-best-529-plans-widget.vue?vue&type=style&index=0&id=738135ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738135ec",
  null
  
)

export default component.exports